'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import uniqid from 'uniqid';
import Layout from 'Layouts/Back';
import moment from 'moment';
import Radio from '@material-ui/core/Radio';
import DefaultModal from 'Modals/DefaultModal';
import DateInput from 'Components/Forms/Elements/DateInput';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import Select from 'Components/Forms/Elements/Select';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import CoworkingSchedule from 'Components/Back/CoworkingSchedule';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import Link from 'Pure/Link';
import { coworking_place_types } from 'Shared/options';
import { isTrue } from 'Shared/utilities';
import { action } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
const date_options = [{
  value: '1',
  label: 'Lundi'
}, {
  value: '2',
  label: 'Mardi'
}, {
  value: '3',
  label: 'Mercredi'
}, {
  value: '4',
  label: 'Jeudi'
}, {
  value: '5',
  label: 'Vendredi'
}, {
  value: '6',
  label: 'Samedi'
}, {
  value: '7',
  label: 'Dimanche'
}];
const availability_status_options = [{
  value: 'open',
  label: 'Ouvert'
}, {
  value: 'close',
  label: 'Fermé'
}];

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class ScheduleConfigurationDashboardPage extends Component {
  state = {
    status_messages: {},
    from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    to: moment().endOf('isoWeek').format('YYYY-MM-DD'),
    etablishment_id: app.state.session.user?.etablishment || app.state.session.user?._etablishment?.id,
    dates: [],
    price_disposition_filter: [],
    price_filter: [],
    date_filter: [],
    type: undefined,
    time_range_type: 'day',
    spaces_options: [],
    spaces_filter: [],
    openResetFilterModal: false
  };
  reset_filter_ref = React.createRef();
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const etablishment_id = app.state.session?.user?.etablishment || app.state.session.user?._etablishment?.id;
    component.fetchSpacesNames({
      etablishment_id: etablishment_id
    });
    component.fetchSpacesAvailability({
      etablishment_id: etablishment_id
    });
  }
  fetchSpacesAvailability = ({
    ...params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const form_data = {};
    ['etablishment_id', 'type', 'spaces_filter', 'from', 'to'].forEach(function (field) {
      form_data[field] = params.hasOwnProperty(field) ? params[field] : state[field];
    });
    component.setState({
      loading: true
    });
    qwest.post(action('getSpacesSpaces'), {
      ...form_data,
      source: 'schedule'
    }).then(function (xhr, response) {
      const spaces = response.data || [];
      const dates = component.computeDatesArray(form_data.from, form_data.to);
      component.setState({
        loading: false,
        spaces: spaces,
        dates: dates
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchSpacesNames = ({
    etablishment_id,
    type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getSpacesSpaces'), {
      etablishment_id: typeof etablishment_id === 'undefined' ? state.etablishment_id : etablishment_id,
      type: typeof type === 'undefined' ? state.type : type,
      source: 'schedule'
    }).then(function (xhr, response) {
      component.setState({
        spaces_options: (response.data || []).map(function (space) {
          const opt = {
            label: space.name,
            id: space.id,
            type: space.type
          };
          return opt;
        }),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleFromDateChange = ({
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const str_value = moment(value).format('YYYY-MM-DD');
    const value_plus_one = moment(value).add(1, "days").format('YYYY-MM-DD');
    const dates = component.computeDatesArray(str_value, value_plus_one);
    component.setState({
      [name]: str_value,
      to: value_plus_one,
      dates: dates,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleToDateChange = ({
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (moment(value).isBefore(state.from, 'date')) {
      value = state.from;
    }
    let str_value = moment(value).format('YYYY-MM-DD');
    const dates = component.computeDatesArray(state.from, str_value);
    component.setState({
      [name]: str_value,
      dates: dates,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  computeDatesArray(from, to) {
    let dates = [];
    let end_date = moment(to, 'YYYY-MM-DD');
    let current_date = moment(from, 'YYYY-MM-DD');
    while (current_date.isSameOrBefore(end_date, 'day')) {
      dates.push(current_date.format('YYYY-MM-DD'));
      current_date = current_date.clone().add(1, 'day');
    }
    return dates;
  }
  handleFilterTypeChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      spaces_filter: [],
      price_update: undefined,
      availability_status: undefined
    });
    component.setState({
      [name]: value
    });
    component.fetchSpacesAvailability({
      type: value,
      spaces_filter: []
    });
  };
  handleSpaceFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["spaces_filter"];
    let spaces = state["spaces_filter"].slice(0);
    if (spaces.includes(name)) {
      spaces = spaces.filter(spaces => spaces !== name);
      component.setState({
        spaces_filter: spaces,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["spaces_filter"];
      spaces.push(name);
      component.setState({
        spaces_filter: spaces,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
    component.fetchSpacesAvailability({
      spaces_filter: spaces
    });
  };
  handleDateFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["date_filter"];
    let dates = state["date_filter"].slice(0);
    if (dates.includes(name)) {
      dates = dates.filter(dates => dates !== name);
      component.setState({
        date_filter: dates,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["date_filter"];
      dates.push(name);
      component.setState({
        date_filter: dates,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
    component.fetchSpacesAvailability({
      date_filter: dates
    });
  };
  setAvailabilityStatus = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.action === 'setAvailability' && !state.availability_status) {
      return component.setState({
        status_messages: {
          availability_status: {
            error: 'Vous devez choisir le statut'
          }
        }
      });
    }
    const is__half_type = ['b_seminar', 'c_open_coworking_space'].includes(state.type);
    if (is__half_type && !state.time_range_type) {
      return component.setState({
        error: 'Vous devez choisir la période à modifier'
      });
    }
    qwest.post(action('setAvailabilitiesSpaces'), {
      etablishment_id: state.etablishment_id,
      type: state.type,
      coworking_spaces_filter: state.spaces_filter,
      availability_status: state.availability_status,
      dates: state.dates,
      date_filter: state.date_filter,
      time_range_type: state.time_range_type,
      reset: state.action === 'resetAvailability'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info
      });
      component.fetchSpacesAvailability({
        etablishment_id: state.etablishment_id
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleActionChange = data => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = data.target?.value;
    const name = data.target?.name;
    component.setState({
      [name]: value,
      info: undefined
    });
  };
  resetFilter = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const dates = component.computeDatesArray(moment().format('YYYY-MM-DD'), moment().add(7, 'day').format('YYYY-MM-DD'));
    component.setState({
      type: undefined,
      availability_status: undefined,
      time_range_type: undefined,
      date_filter: [],
      spaces_filter: [],
      from: moment().format('YYYY-MM-DD'),
      to: moment().add(7, 'day').format('YYYY-MM-DD'),
      dates: dates
    });
    component.fetchSpacesAvailability({
      etablishment_id: state.etablishment_id,
      type: undefined,
      from: moment().format('YYYY-MM-DD'),
      to: moment().add(7, 'day').format('YYYY-MM-DD')
    });
    component.closeResetFilterModal();
  };
  openResetFilterModal = ({
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openResetFilterModal: true,
      reset_filter_modal_trigger: e.target
    });
  };
  closeResetFilterModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openResetFilterModal: false,
      reset_filter_modal_trigger: undefined
    });
  };
  exportCSV = async () => {
    const component = this,
      props = this.props,
      state = this.state;
    try {
      var response = await ajaxRequest(action('exportSpaceAvailabalityCsv'), {
        data: {
          etablishment_id: state.etablishment_id
        }
      });
    } catch (e) {
      console.log(e);
    }
    component.setState({
      csv_link: response.link
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const isSuperAdmin = app.state.session.user.super_admin;
    const status = getFormStatus(state);
    const is__half_type = ['b_seminar', 'c_open_coworking_space'].includes(state.type);
    const spaces_selection = (state.spaces_options || []).filter(data => !state.type || data.type === state.type).map(function (data) {
      const output = /*#__PURE__*/React.createElement("div", {
        className: "c-price__filter",
        key: data.id
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleSpaceFilterChange,
        label: data.label,
        name: data.id,
        value: state['spaces_filter'].includes(data.id),
        status: state.status_messages
      }));
      return output;
    });
    const dates_filter = (date_options || []).map(function (date) {
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-price__filter",
        key: uniqid()
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleDateFilterChange,
        label: date.label,
        name: date.value,
        value: state['date_filter'].includes(date.value),
        status: state.status_messages
      }));
      return output;
    });
    const dates = (state.dates || []).map(function (date) {
      moment.locale("fr");
      let output = /*#__PURE__*/React.createElement("div", {
        key: date,
        className: (moment(date).format('ddd') === "dim." ? "c-coworking-space__price__row__col--weekend " : "") + "c-coworking-space__price__row__col c-coworking-space__price__row__col--date"
      }, /*#__PURE__*/React.createElement("span", null, moment(date).format('ddd'), " ", ' ', " ", moment(date).format('DD')), /*#__PURE__*/React.createElement("span", null, moment(date).format('MMM')));
      return output;
    });
    let coworking_spaces = (state.spaces || []).map(function (coworking_space) {
      moment.locale('en');
      let columns = (state.dates || []).map(function (date) {
        const output = /*#__PURE__*/React.createElement(CoworkingSchedule, {
          key: date,
          date: date,
          space: coworking_space,
          schedule: coworking_space.schedule || {}
        });
        return output;
      });
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space c-coworking-space--row",
        key: coworking_space.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space__name"
      }, coworking_space.name, ['c_open_coworking_space', 'b_seminar'].includes(coworking_space.type) ? /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space__seminar-title"
      }, /*#__PURE__*/React.createElement("span", null, "Matin"), /*#__PURE__*/React.createElement("span", null, "Apr\xE8s-midi")) : undefined), /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space__price"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space__price__row c-coworking-space__price__row--schedule"
      }, columns)));
      return output;
    });
    const spaces_types_radios = coworking_place_types.map(function (option) {
      const output = /*#__PURE__*/React.createElement("div", {
        key: option.value,
        className: "c-filters__element-radio"
      }, /*#__PURE__*/React.createElement(Radio, {
        checked: state['type'] === option.value,
        onChange: component.handleFilterTypeChange,
        value: option.value,
        color: "primary",
        name: "type",
        inputProps: {
          'aria-label': option.label
        },
        className: "mui-radio"
      }), /*#__PURE__*/React.createElement("span", {
        onClick: e => component.handleFilterTypeChange({
          target: {
            value: option.value,
            name: 'type'
          }
        })
      }, option.label));
      return output;
    });
    const period_to_update_filters = /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "P\xE9riode \xE0 modifier\xA0:"), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radios"
    }, is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['time_range_type'] === "morning",
      onChange: component.handleActionChange,
      value: "morning",
      color: "primary",
      name: "time_range_type",
      inputProps: {
        'aria-label': 'Matin'
      },
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'morning',
          name: 'time_range_type'
        }
      })
    }, "Matin")) : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['time_range_type'] === "afternoon",
      onChange: component.handleActionChange,
      value: "afternoon",
      color: "primary",
      name: "time_range_type",
      inputProps: {
        'aria-label': 'Après-midi'
      },
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'afternoon',
          name: 'time_range_type'
        }
      })
    }, "Apr\xE8s-midi")) : undefined, /*#__PURE__*/React.createElement("div", {
      className: 'c-filters__element-radio' + (!is__half_type ? ' is-disabled' : '')
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['time_range_type'] === 'day' || !is__half_type,
      onChange: component.handleActionChange,
      value: "day",
      color: "primary",
      name: "time_range_type",
      inputProps: {
        'aria-label': 'Journée'
      },
      disabled: !is__half_type,
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'day',
          name: 'time_range_type'
        }
      })
    }, "Journ\xE9e"))));
    const filters_area = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement("strong", null, "D\xE9but de p\xE9riode\xA0:"), /*#__PURE__*/React.createElement(DateInput, {
      onChange: component.handleFromDateChange,
      value: state['from'],
      label: "",
      className: "c-filters__element__date-input",
      name: "from"
      //minDate={moment().toDate()}
      ,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement("strong", null, "Fin de p\xE9riode :"), /*#__PURE__*/React.createElement(DateInput, {
      onChange: component.handleToDateChange,
      value: state['to'],
      className: "c-filters__element__date-input",
      label: "",
      name: "to"
      //minDate={moment().toDate()}
      ,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element\r c-filters__element--price-configuration "
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Type / Tous si aucun coch\xE9\xA0:"), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radios"
    }, spaces_types_radios)), /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Espace(s) / Tous si aucun coch\xE9\xA0:"), spaces_selection)), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--price-configuration"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Jour(s) \xE0 modifier / Tous si aucun coch\xE9\xA0:"), dates_filter), period_to_update_filters, /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Actions\xA0:"), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radios"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['action'] === "resetAvailability",
      onChange: component.handleActionChange,
      value: "resetAvailability",
      color: "primary",
      name: "action",
      className: "mui-radio",
      inputProps: {
        'aria-label': 'Rénitialiser le statut'
      }
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'resetAvailability',
          name: 'action'
        }
      })
    }, "R\xE9nitialiser le statut")), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['action'] === "setAvailability",
      onChange: component.handleActionChange,
      value: "setAvailability",
      color: "primary",
      name: "action",
      className: "mui-radio",
      inputProps: {
        'aria-label': 'Modifier le statut'
      }
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'setAvailability',
          name: 'action'
        }
      })
    }, "Modifier le statut"))))), state.from && state.to && state.action === "setAvailability" ? /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: availability_status_options,
      defaultValue: availability_status_options[0]?.value,
      onChange: component.handleChange,
      value: state['availability_status'],
      name: "availability_status",
      type: "text",
      label: "",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']) + ' u-margin-left-10',
      onClick: component.setAvailabilityStatus
    }, "Mettre \xE0 jour")))) : state.from && state.to && state.action === "resetAvailability" ? /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.setAvailabilityStatus
    }, "R\xE9initialiser les statuts")))) : undefined));
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Gestion des disponibilit\xE9s"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--price-dashboard"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: e => component.openResetFilterModal({
        e: e
      })
    }, "R\xE9initialiser les filtres")), filters_area, status), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space-prices"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space c-coworking-space--date"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__name"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row c-coworking-space__price__row--date"
    }, dates))), coworking_spaces), /*#__PURE__*/React.createElement("div", {
      className: "u-flex u-flex-wrap u-margin-top-10"
    }, /*#__PURE__*/React.createElement("p", {
      className: bemit('c-legend', ['round', 'open'])
    }, "Ouvert"), /*#__PURE__*/React.createElement("p", {
      className: bemit('c-legend', ['round', 'closed'])
    }, "Ferm\xE9"), /*#__PURE__*/React.createElement("p", {
      className: bemit('c-legend', ['round', 'open', 'manual'])
    }, "Ouvert manuellement"), /*#__PURE__*/React.createElement("p", {
      className: bemit('c-legend', ['round', 'closed', 'manual'])
    }, "Ferm\xE9 manuellement")), isSuperAdmin ? /*#__PURE__*/React.createElement("div", {
      className: "u-flex u-content-end u-margin-right-15"
    }, /*#__PURE__*/React.createElement(Button, {
      href: `/coworking-space/export-spaces-availabality-csv?etablishment_id=${state.etablishment_id}&from=${state.from}&to=${state.to}`,
      className: bemit('c-flat-btn', ['primary']),
      target: "_blank",
      component: Link
    }, "Exporter les disponibilit\xE9s en CSV")) : undefined))), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.openResetFilterModal,
      title: "R\xE9initialiser les filtres",
      trigger_src: state.reset_filter_modal_trigger,
      "close-ref": component.reset_filter_ref,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeResetFilterModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--blue"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "\xCAtes vous s\xFBr de vouloir r\xE9initialiser les filtres ?")), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-15",
      onClick: component.resetFilter
    }, "R\xE9initialiser"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.reset_filter_ref?.current?.click()
    }, "Annuler"))));
    return output;
  }
}
